<script lang="ts">
import { iIcon } from '@inscribe/signal';

export default {
  name: 'UpsellScreenBox',
  components: { iIcon },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="upsell-screen-box d-flex flex-column i-radius-2xl i-p-11">
    <i-icon :symbol="icon" :size="24" class="i-text-primary-120" />
    <div class="text-container d-flex flex-column i-mt-9 i-gap-4">
      <span class="i-text-heading-5 i-text-neutral-120">{{ title }}</span>
      <span class="i-text-body-2 i-text-neutral-120">{{ description }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upsell-screen-box {
  width: 389px;
  border: 1px solid $light-neutral-60;
}
</style>
